export default __webpack_public_path__ + "3665616ad0fb336d0b945fa267893aa1.svg";